var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavViewedcontacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0.613098H4C3.46957 0.613098 2.96086 0.823812 2.58579 1.19888C2.21071 1.57396 2 2.08267 2 2.6131V5.6131H0V7.6131H2V9.6131H0V11.6131H2V13.6131H0V15.6131H2V18.6131C2 19.1435 2.21071 19.6522 2.58579 20.0273C2.96086 20.4024 3.46957 20.6131 4 20.6131H19C19.2652 20.6131 19.5196 20.5077 19.7071 20.3202C19.8946 20.1327 20 19.8783 20 19.6131V1.6131C20 1.34788 19.8946 1.09353 19.7071 0.905991C19.5196 0.718455 19.2652 0.613098 19 0.613098ZM11 3.6121C12.648 3.6121 14 4.9631 14 6.6121C13.9971 7.40695 13.6801 8.16843 13.1182 8.73057C12.5562 9.29271 11.7948 9.60994 11 9.6131C9.353 9.6131 8 8.2601 8 6.6121C8 4.9631 9.353 3.6121 11 3.6121ZM17 16.6131H5V15.8631C5 13.6441 7.705 11.3631 11 11.3631C14.295 11.3631 17 13.6441 17 15.8631V16.6131Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0.613098H4C3.46957 0.613098 2.96086 0.823812 2.58579 1.19888C2.21071 1.57396 2 2.08267 2 2.6131V5.6131H0V7.6131H2V9.6131H0V11.6131H2V13.6131H0V15.6131H2V18.6131C2 19.1435 2.21071 19.6522 2.58579 20.0273C2.96086 20.4024 3.46957 20.6131 4 20.6131H19C19.2652 20.6131 19.5196 20.5077 19.7071 20.3202C19.8946 20.1327 20 19.8783 20 19.6131V1.6131C20 1.34788 19.8946 1.09353 19.7071 0.905991C19.5196 0.718455 19.2652 0.613098 19 0.613098ZM11 3.6121C12.648 3.6121 14 4.9631 14 6.6121C13.9971 7.40695 13.6801 8.16843 13.1182 8.73057C12.5562 9.29271 11.7948 9.60994 11 9.6131C9.353 9.6131 8 8.2601 8 6.6121C8 4.9631 9.353 3.6121 11 3.6121ZM17 16.6131H5V15.8631C5 13.6441 7.705 11.3631 11 11.3631C14.295 11.3631 17 13.6441 17 15.8631V16.6131Z",
    fill: "url(#paint0_linear_698_4809)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_4809",
    x1: 0,
    y1: 10.6441,
    x2: 20.1126,
    y2: 10.6441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavViewedcontacts);
export default __webpack_public_path__ + "static/media/sidenav_viewedcontacts.703528e15ad53be5b1ddfce4c061e247.svg";
export { ForwardRef as ReactComponent };